import type { IFareClassOption } from "@b2bportal/core-flights";
import { FareClassEnum } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";

export const useFareClassOptions = () => {
  const { t } = useI18nContext();

  // RBC only supports 4 fare classes (excluding Enhanced)
  const fareClassOptions: IFareClassOption[] = [
    {
      label: t("fareClass.basicLabel"),
      value: FareClassEnum.basic,
    },
    {
      label: t("fareClass.standardLabel"),
      value: FareClassEnum.standard,
    },
    {
      label: t("fareClass.premiumLabel"),
      value: FareClassEnum.premium,
    },
    {
      label: t("fareClass.luxuryLabel"),
      value: FareClassEnum.luxury,
    },
  ];

  return {
    context: { fareClassOptions },
  };
};
